module.exports = __webpack_public_path__ + "static/media/marker-empty.5423e13e.png";